<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('modules.title') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="card b" v-for="row in rows" :key="row.id">
            <div class="card-body text-center">
              <a class="link-unstyled text-purple">
                <em class="fa-5x fa fa-cubes mb-3"></em>
                <br>
                <span class="h4">{{ row.name }}</span>
                <label class="badge badge-success" v-if="row.is_active">{{ $t('modules.active') }}</label>
                <label class="badge badge-light" v-if="!row.is_active">{{ $t('modules.inactive') }}</label>
                <br>
                <div class="text-sm text-muted">
                  <router-link :to="{name: 'module_edit', params: {id: row.id}}">{{ $t('modules.config') }} &rarr;</router-link>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'

const getData = (route, next) => {
  api.get('/modules/')
    .then(resp => {
      next({
        rows: resp.data.results
      })
    })
}

export default {
  data () {
    return {
      rows: []
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'modules'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  },
  beforeRouteEnter (to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Modules.vue